import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';


const PurchaseMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');
  const user_role = localStorage.getItem('user_role');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false);
  const [prdmodalVisible, setPrdModalVisible] = useState(false);  
  const [addPrdmodalVisible, setAddPrdModalVisible] = useState(false);      
  

  const [purchases, setPurchases] = useState([]);
  const [selectedPurchase, setSelectedPurchase] = useState([]);
 
  const [selectedPurchaseDetail, setSelectedPurchaseDetail] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [productUnits, setProductUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState('');
  

  const [catList, setCatList] = useState([]);
  const [selectedCatList, setSelectedCatList] = useState('');
  const [productList, setProductList] = useState([]);
  const [selectedAddProductId, setSelectedAddProductId] = useState('');
  const [selectedAddProductQty, setSelectedAddProductQty] = useState('');
  const [selectedAddProductAmt, setSelectedAddProductAmt] = useState('');
  
  const [accList, setAccList] = useState([]);
  const [accSelected, setAccSelected] = useState('');
  
  const today = new Date().toISOString().split("T")[0];
  const [entryDate, setEntryDate] = useState(today);


  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible) {
            if (prdmodalVisible || addPrdmodalVisible) {
              setPrdModalVisible(false);
              setAddPrdModalVisible(false);
            } else {
              setModalVisible(false);
              setAddModalVisible(false);
            }
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert") {
          if (modalVisible) {
            setSelectedAddProductId('');
            setSelectedAddProductQty('');
            setSelectedAddProductAmt('');
            setAddPrdModalVisible(true);
          } else {
            if(addmodalVisible) {
              setAddPrdModalVisible(true);
            } else {
              setAddModalVisible(true);
            }
          }
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible, prdmodalVisible, addPrdmodalVisible]);

    useEffect(() => { 
      const fetchPurchaseList = async () => { 
          try {
            const response = await fetch(`${host_url}/purchase_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                ordersList: '',
                prddetail: '', 
              }),
            });
            const data = await response.json();
            setPurchases(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchPurchaseList(); 
    }, [host_url, selectedPurchaseDetail]); // Purchase List
     
    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          try {
            const response = await fetch(`${host_url}/category`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                lang: 'Gujarati',
                store: store,
              }),
            });
            
            const data = await response.json();
            setCatList(data);
            setSelectedCatList(data[0].pcat_id)
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url, store]);  // Category List

    useEffect(() => { 
      const fetchProductList = async () => { 
          try {
            const response = await fetch(`${host_url}/product_admin`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                lang: 'Gujarati',
                store: store,
                pcatId: selectedCatList,
              }),
            });            
            const data = await response.json();
            if(data.length > 0 ) {
              data.sort((a, b) => a.prd_name.trim().localeCompare(b.prd_name.trim(), 'gu'));
              setProductList(data);
              setSelectedAddProductId(data[0].prd_id);
            }
            
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
       
      }; 
     fetchProductList(); 
    }, [selectedCatList]);  // Product List

        
    useEffect(() => { 
      
        const accountDetail = {
            acc_type: 'Pur_Party',
        };
        const fetchAccountDetail = async () => { 
          try {
            const response = await fetch(`${host_url}/account_select`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                accDetail: accountDetail,
              }),
            });            
            const data = await response.json();
            setAccList(data);              
           
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
        }; 
       fetchAccountDetail();  
    }, [addmodalVisible]); // Account Detail

   

    const sdate = new Date();
    sdate.setMonth(sdate.getMonth() - 3);
    sdate.setDate(1);
    const ThreeMonthAgo = sdate.toISOString().split("T")[0];
    
    const [startDate, setStartDate] = useState(ThreeMonthAgo);
    const [endDate, setEndDate] = useState(today);
    const [accNameFilter, setAccNameFilter] = useState('');

    const filteredPurchase = purchases.filter(pur =>{
      const purchaseDate = new Date(pur.pl_date); 
      const start = startDate ? new Date(startDate) : null;
      if (start) {
        start.setDate(start.getDate() - 1); // Subtract 1 day
      }
      const end = endDate ? new Date(endDate) : null;
      
      return (
        pur.acc_name.toLowerCase().includes(accNameFilter.toLowerCase()) &&
        (!start || purchaseDate >= start) && 
        (!end || purchaseDate <= end)
      );
    });

    const totalCount = filteredPurchase.length;
    const totalPurAmt = filteredPurchase.reduce((sum, pur) => sum + Number(pur.pl_amt), 0);

    const detailtotalWeight = selectedPurchaseDetail.reduce((sum, product) => sum + Number(product.pd_prd_qty), 0);
    const detailtotalAmt = selectedPurchaseDetail.reduce((sum, product) => sum + Number(product.pd_prd_amt), 0);

    

    const handlePurchaseDetail = async (pur) => {
      setModalVisible(true);
      setSelectedPurchase(pur);
      setSelectedPurchaseDetail([]);
      const purchaseDetail = {
            pl_id: pur.pl_id,
        };
      try {
        const response = await fetch(`${host_url}/purchase_select`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'list', 
            store: store, 
            purdetail: purchaseDetail,  
          }),
        });
        const data = await response.json();
        setSelectedPurchaseDetail(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handlePurchaseDelete = async () => {
        const userConfirmed = window.confirm('Are you sure you want to delete this Entry?');
        if (userConfirmed) {
          const purDetail = {
              pl_id: selectedPurchaseDetail[0].pd_pl_id,
              pl_amt: selectedPurchase.pl_amt,
              pl_acc_id: selectedPurchase.pl_acc_id
          };
          
          try {
            const response = await fetch(`${host_url}/purchase_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'pur_delete', 
                store: store, 
                purList: purDetail,
                prddetail: '',
              }),
            });
            const data = await response.json();
            setPurchases(data);
            setSelectedPurchaseDetail([]);
            setModalVisible(false);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
        }
    };

    const hamdlePurchaseAddModal = () => {
      setAddModalVisible(true);
      setSelectedPurchaseDetail([]);
      setAccSelected('');
    };

    const handleProductAddInNewOrder = async () => {
      if (selectedAddProductId) {
        const prd_name = productList.find(product => product.prd_id == selectedAddProductId)?.prd_name;
        const purAddDetail = {
            pl_id: 0,
            prd_name: prd_name,
            pd_prd_id: selectedAddProductId,
            pd_prd_qty: selectedAddProductQty || 0,
            pd_prd_amt: selectedAddProductAmt || 0,
        };

        setSelectedPurchaseDetail(prevDetails => [...prevDetails, purAddDetail]);
        setSelectedAddProductId('');
        setSelectedAddProductQty('');
        setSelectedAddProductAmt('');
                 
      } else {
        alert('Please Selct Product');
        
      }
    };

    const handlePurchaseSubmit = async () => {
      setAddModalVisible(false);
      const purlistDetail = {
            pl_date: entryDate,
            pl_acc_id: accSelected,
        };
        console.log(selectedPurchaseDetail);
      try {
        const response = await fetch(`${host_url}/purchase_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'pur_Insert', 
            store: store, 
            purList: purlistDetail,
            prddetail: selectedPurchaseDetail, 
          }),
        });
        const data = await response.json();
        setPurchases(data);
        setSelectedPurchaseDetail([]);
               
      } catch (error) {
        console.error('Error fetching cities:', error);
      } 
    };


    const handleProduct = async (row) => {
      setPrdModalVisible(true);
      setSelectedProduct(row);
      setSelectedCatList(row.pcat_id); 
    };

    const handleProductAdd = async () => {
      if (selectedAddProductId) {
        const purAddDetail = {
            pl_id: selectedPurchaseDetail[0].pd_pl_id,
            prd_id: selectedAddProductId,
            prd_qty: selectedAddProductQty,
            prd_amt: selectedAddProductAmt,
        };

        try {
          const response = await fetch(`${host_url}/purchase_select`, {
            method: 'POST', 
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              type: 'Add_Product', 
              store: store, 
              purdetail: purAddDetail,
            }),
          });
          const data = await response.json();
          setSelectedPurchaseDetail(data);

          setProductUnits([]);
          setSelectedUnit('');
          setSelectedAddProductId('');
          setAddPrdModalVisible(false);
        } catch (error) {
          console.error('Error fetching cities:', error);
        }

        
      } else {
        alert('Please Selct Product And Units');
        
      }
    };

    const handleProductUpdate = async () => {
      setPrdModalVisible(false); 
      const purupdateDetail = {
            pd_id: selectedProduct.pd_id,
            pl_id: selectedPurchaseDetail[0].pd_pl_id,
            prd_id: selectedProduct.pd_prd_id,
            prd_qty: selectedProduct.pd_prd_qty,
            prd_amt: selectedProduct.pd_prd_amt,
        };


      try {
        const response = await fetch(`${host_url}/purchase_select`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'Update_Product', 
            store: store, 
            purdetail: purupdateDetail, 
          }),
        });
        const data = await response.json();
        setSelectedPurchaseDetail(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };
    
    const handleProductDelete = async () => {
        const userConfirmed = window.confirm('Are you sure you want to delete this product?');
        if (userConfirmed) {
          const purdeleteDetail = {
            pd_id: selectedProduct.pd_id,
            pl_id: selectedPurchaseDetail[0].pd_pl_id,
            pd_prd_id: selectedProduct.pd_prd_id,
            pd_prd_qty: selectedProduct.pd_prd_qty,
            pd_prd_amt: selectedProduct.pd_prd_amt,
        };
          console.log(purdeleteDetail);
          
          try {
            const response = await fetch(`${host_url}/purchase_select`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'Delete_Product', 
                store: store, 
                purdetail: purdeleteDetail,
              }),
            });
            const data = await response.json();
            console.log(data);
            setSelectedPurchaseDetail(data);
            setPrdModalVisible(false);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
        }
    };
    
  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Purchase Master</b>
                <div onClick={hamdlePurchaseAddModal}>
                  <img src={insertlogo} alt="Back" className='system-icon'/>
                </div>
          </div>
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >        
                <th >Date</th>
                <th colSpan='2'>Name</th>
                <th>Amount</th>
              </tr>
              <tr>
                <th style={{ paddingRight: '10px', display: 'flex', justifyContent: 'space-between'}}>
                  <input type="date" className='search-input no-icon' style={{ width: '45%', textAlign: 'center' }} value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                  <input type="date" className='search-input no-icon' style={{ width: '45%', textAlign: 'center' }} value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={accNameFilter}
                    onChange={(e) => setAccNameFilter(e.target.value)}
                  />
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredPurchase.map((row) => {
                  return (
                    <tr key={row.pl_id} style={{ lineHeight: '10px' }} onClick={() => handlePurchaseDetail(row)}>
                      <td > {new Date(row.pl_date).toLocaleDateString("en-GB").replace(/\//g, "-")}</td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px', fontSize: '14px' }} >{row.acc_name}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.pl_amt}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left" ><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th colSpan='2' className="cell-left" ><span style={{ paddingLeft: '10px' }}></span></th>
                <th className="cell-right" ><span style={{ paddingRight: '15px' }}>{totalPurAmt}</span></th>
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Purchase Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h6>{selectedPurchase.acc_name} - {new Date(selectedPurchase.pl_date).toLocaleDateString("en-GB").replace(/\//g, "-")}</h6>                
                  <div>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >Item</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Qty</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Rate</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Amount</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {selectedPurchaseDetail.map((row) => {
                            return (
                              <tr key={row.prd_id} style={{ cursor: 'pointer' }} onClick={() => handleProduct(row)}>
                                <td colSpan='2' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.pd_prd_qty}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{(row.pd_prd_amt/row.pd_prd_qty).toFixed(2)}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.pd_prd_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody> 
                      <tfoot>
                        <tr>
                          <th colSpan='2' className="cell-left"style={{ padding: '2px' }} >Total</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalWeight.toFixed(3)}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} ></th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalAmt}</th>
                        </tr> 
                      </tfoot>
                    </table>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%', margin: '0 auto' }}>
                      <Button color="danger" style={{ flex: 1, marginLeft: '10px'}} onClick={handlePurchaseDelete}  disabled={user_role !== 'Admin' }>
                        Delete Entry
                      </Button>
                      <Button color="success" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={() => setAddPrdModalVisible(true)}  disabled={selectedPurchase.ordStatus === 'Out For Delivery' || selectedPurchase.ordStatus === 'Ready For Delivery'}>
                        Add New 
                      </Button>
                      <Button color="primary" style={{ flex: 1, marginRight: '10px' }} onClick={() => setModalVisible(false)}>
                        Close
                      </Button>
                    </div>
                  </div>
              </ModalBody>
            </Modal>

          {/* Modal for Add New Purchase  */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '90%', margin: '0 auto' }}>
                    <span> 
                      <select
                        value={accSelected}
                        onChange={(e) => setAccSelected(e.target.value)}
                      >
                        <option key='' value=''>Select Party</option>
                        {accList.map((accList, index) => (
                            <option key={index} value={accList.sacc_id}>
                              {accList.sacc_name}
                            </option>
                        ))}
                      </select>
                    </span>  
                    <span> 
                      <input type="date" className='no-icon'  value={entryDate} onChange={(e) => setEntryDate(e.target.value)} />
                    </span> 
                </div> 
                <div>
                  <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th colSpan='2' className="cell-left" style={{ padding: '2px' }} >Item</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Qty</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Rate</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Amount</th>
                      </tr>
                    </thead>
                    <tbody className="scrollable-body">
                      {selectedPurchaseDetail.map((row) => {
                          return (
                            <tr key={row.prd_id} style={{ cursor: 'pointer' }} >
                              <td colSpan='2' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                              <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.pd_prd_qty}</td>
                              <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{(row.pd_prd_amt/row.pd_prd_qty).toFixed(2)}</td>
                              <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.pd_prd_amt}</td>
                            </tr>
                          );
                      })}
                    </tbody> 
                    <tfoot>
                      <tr>
                        <th colSpan='2' className="cell-left"style={{ padding: '2px' }} >Total</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalWeight.toFixed(3)}</th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} ></th>
                        <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalAmt}</th>
                      </tr> 
                    </tfoot>
                  </table>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '50%', margin: '0 auto' }}>
                    <Button color="info" style={{ flex: 1, marginLeft: '10px'}} onClick={() => setAddPrdModalVisible(true)} >
                      Add New 
                    </Button>
                     <Button color="success" style={{ flex: 1, marginLeft: '10px', marginRight: '10px'}} onClick={handlePurchaseSubmit}  disabled={!accSelected || !entryDate || selectedPurchaseDetail.length < 1}>
                      Submit Entry 
                    </Button>
                    <Button color="primary" style={{ flex: 1, marginRight: '10px' }} onClick={() => setAddModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                </div>
                
              </ModalBody>
            </Modal>
         
          {/* Modal for Product Detail */}
            <Modal isOpen={prdmodalVisible} toggle={() => setModalVisible(!prdmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}> 
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td>Catagory</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                value={selectedCatList}
                                onChange={(e) => setSelectedCatList(e.target.value)}
                              >
                                {catList.map((catList, index) => (
                                    <option key={index} value={catList.pcat_id}>
                                      {catList.pcat_name}
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td>Product</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                value={selectedProduct.pd_prd_id}
                                onChange={(e) => setSelectedProduct({ ...selectedProduct, pd_prd_id: e.target.value })}
                              >
                                <option key='' value=''>Select Product</option>
                                {productList.map((plist, index) => (
                                    <option key={index} value={plist.prd_id}>
                                      {plist.prd_name} 
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td>Qty</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedProduct.pd_prd_qty}
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, pd_prd_qty: e.target.value })}
                            />
                          </td>  
                        </tr>
                        <tr>
                          <td>Amount</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedProduct.pd_prd_amt}
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, pd_prd_amt: e.target.value })}
                            />
                          </td>    
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="danger" style={{ flex: 1, marginRight: '10px' }} onClick={handleProductDelete} disabled={selectedPurchaseDetail.length < 2 }>
                      Delete Product
                    </Button>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleProductUpdate} >
                      Update Product
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setPrdModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>        

          {/* Modal for Add Product Detail */}
            <Modal isOpen={addPrdmodalVisible} toggle={() => setModalVisible(!addPrdmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td>Catagory</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                value={selectedCatList}
                                onChange={(e) => setSelectedCatList(e.target.value)}
                              >
                                {catList.map((catList, index) => (
                                    <option key={index} value={catList.pcat_id}>
                                      {catList.pcat_name}
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td>Product</td>
                          <td style={{ padding: '2px' }} >
                              <select
                                onChange={(e) => setSelectedAddProductId(e.target.value)}
                              >
                                <option key='' value=''>Select Product</option>
                                {productList.map((plist, index) => (
                                    <option key={index} value={plist.prd_id}>
                                      {plist.prd_name} 
                                    </option>
                                ))}
                              </select>
                          </td>    
                        </tr>
                        <tr>
                          <td>Qty</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedAddProductQty}
                              onChange={(e) => setSelectedAddProductQty(e.target.value)}
                            />
                          </td>  
                        </tr>
                        <tr>
                          <td>Amount</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedAddProductAmt}
                              onChange={(e) => setSelectedAddProductAmt(e.target.value)}
                            />
                          </td>    
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={modalVisible ? handleProductAdd : handleProductAddInNewOrder}>
                      Add Product
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setAddPrdModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>        
    </div>
  );
};

export default PurchaseMaster;
